<script>

export default {
  name: "MetersComponent",
  props: ['meters'],
  data() {
    return {
      map: {
        land_area: {
          svg: '/svg/icons/square.svg',
          fn: (meter) => meter.value ? `Acres: ${this.addCommasToNumbers(meter.value)}` : false,
        },
        engine: {
          svg: '/svg/icons/we_clock.svg',
          fn: (meter) => meter.value ? `Engine: ${this.addCommasToNumbers(meter.value)} hrs` : false,
        },
        fan_hours: {
          svg: '/svg/icons/we_clock.svg',
          fn: (meter) => meter.value ? `Fan: ${this.addCommasToNumbers(meter.value)} hrs` : false,
        },
        cutter_head_hours: {
          svg: '/svg/icons/we_clock.svg',
          fn: (meter) => meter.value ? `Head: ${this.addCommasToNumbers(meter.value)}` : false,
        },
        bale_count: {
          svg: '/svg/icons/bale.svg',
          fn: (meter) => meter.value ? `Bale Count: ${this.addCommasToNumbers(meter.value)}` : false,
        },
      }
    }
  },
  methods: {
    addCommasToNumbers(num) {
      return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  }
}
</script>

<template>
  <div class="flex flex-col">
    <template v-for="meter in meters">
      <div class="flex items-center" v-if="map[meter.key] && map[meter.key].fn(meter)">
        <img class="h-4 w-4 mr-1" :src="map[meter.key].svg"/>
        <span>{{ map[meter.key].fn(meter) }}</span>
      </div>
    </template>
  </div>
</template>



// WEBPACK FOOTER //
// resources/js/Components/new/MetersComponent.vue